import { render, staticRenderFns } from "./comfirmDeleteModal.vue?vue&type=template&id=d46466e8&scoped=true&"
import script from "./comfirmDeleteModal.vue?vue&type=script&lang=js&"
export * from "./comfirmDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./comfirmDeleteModal.vue?vue&type=style&index=0&id=d46466e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46466e8",
  null
  
)

export default component.exports